import script from "./DeviceGroupRootEntry.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceGroupRootEntry.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceGroupRootEntry.vue?vue&type=style&index=0&id=1b42f0b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b42f0b6"]])

export default __exports__